<template>
  <div class>
    <div v-if="tradeDetail" class="pocket-wrap">
      <div class="trade-base-info">
        <p class="trade-money">{{ tradeDetail.consumeTimeDetail }}</p>
        <p class="trade-ways">{{ tradeDetail.tradeDesc }}</p>
      </div>
      <ul class="trade-detail-info">
        <li v-if="tradeDetail.status" class="detail-item">
          <span class="detail-sub-title">当前状态</span>
          <span class="detail-sub-content">{{ tradeDetail.status }}</span>
        </li>
        <li v-if="tradeDetail.payPrice" class="detail-item">
          <span class="detail-sub-title">交易金额</span>
          <span class="detail-sub-content">{{ tradeDetail.payPrice }}</span>
        </li>
        <li v-if="tradeDetail.joinTime && tradeDetail.timeStr" class="detail-item">
          <span class="detail-sub-title">{{ tradeDetail.timeStr}}</span>
          <span class="detail-sub-content">{{ tradeDetail.joinTime }}</span>
        </li>
        <li v-if="tradeDetail.cancelTime" class="detail-item">
          <span class="detail-sub-title">退换时间</span>
          <span class="detail-sub-content">{{ tradeDetail.cancelTime }}</span>
        </li>
        <li v-if="tradeDetail.payType" class="detail-item">
          <span class="detail-sub-title">支付方式</span>
          <span class="detail-sub-content">{{ tradeDetail.payType }}</span>
        </li>
        <li class="detail-item">
          <span class="detail-sub-title">交易单号</span>
          <span class="detail-sub-content">{{ tradeDetail.tradeNo }}</span>
        </li>
      </ul>
    </div>
    <div v-if="loading" class="spinner-wrap">
      <div class="snake-wrap">
        <mt-spinner type="triple-bounce"></mt-spinner>
      </div>
    </div>
  </div>
</template>

<script type="text/javascript">
import Vue from "vue";
import encrypt from "components/plugin/lib/encrypt.js";

Vue.filter("amount_convert", function(val) {
  return (val / 100).toFixed(2);
});

export default {
  data() {
    return {
      tradeDetail: null,
      red_envelope: false, // 蓝色字体 && 可以跳走
      loading: 1,
      userId: "",
      tradeId: ""
    };
  },
  beforeRouteEnter(to, from, next) {
    let params = {
      userId: to.query.userId,
      tradeId: to.query.tradeId
    };

    Vue.http
      .get("/circle2/v1/card/tradeDetail", { params: encrypt(params) })
      .then(res => {
        if (res.body.status != 1) return;
        next(vm => {
          let tradeDetail = res.body.data.tradeDetail;
          vm.tradeDetail = tradeDetail;
          vm.loading = 0;
        });
      });
  },
  methods: {}
};
</script>

<style scoped lang="less">
@import "~assets/lib/mixin";

.trade-base-info {
  padding: 42px 0 40px;
  margin: 0 16px;
  // .setLine("bottom", #E5E5E5);
  border-bottom: 0.5px solid #e5e5e5;
  p {
    text-align: center;
  }
  .trade-money {
    line-height: 30px;
    font-weight: 600;
    font-family: PingFangSC-Semibold;
    font-size: 30px;
    color: #1a1a1a;
    span {
      font-family: PingFangSC-Regular;
      font-size: 17px;
      color: #1a1a1a;
      margin-left: 4px;
      font-weight: normal;
    }
  }
  .trade-ways {
    margin-top: 8px;
    line-height: 16px;
    font-family: PingFangSC-Regular;
    font-size: 16px;
    color: #1a1a1a;
  }
}

.trade-detail-info {
  padding: 23px 15px 20px;
  .setLine("bottom", @lineColor);
  .detail-item {
    .flex();
    .justify-content(space-between);
    line-height: 30px;
    span {
      font-family: PingFangSC-Regular;
      font-size: 16px;
    }
    .detail-sub-title {
      color: #b3b3b3;
      min-width: 60px;
      margin-right: 15px;
      &.detail-sub-failreason {
      }
      .settleRatio,
      .currTaxAmount {
        display: inline-block;
        width: 16px;
        height: 16px;
        background: url("~assets/settleRatio.png") center no-repeat;
        background-size: contain;
        margin-left: 5px;
        vertical-align: middle;
      }
    }
    .detail-sub-content {
      color: #000;
      &.red-envelope {
        color: #007aff;
        &:active {
          color: #005abc;
        }
      }
      .goods-name {
        max-width: 200px;
        .one-line;
      }
    }
  }
}

.spinner-wrap {
  .snake-wrap {
    width: 28px;
    margin: 0 auto;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/page/trade/planeTrade.vue